import { render, staticRenderFns } from "./ConfirmationCodeStep.vue?vue&type=template&id=0c9e39c0&scoped=true&"
import script from "./ConfirmationCodeStep.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCodeStep.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationCodeStep.vue?vue&type=style&index=0&id=0c9e39c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e39c0",
  null
  
)

export default component.exports